export const DEFAULT_TIME_WEIGHTED_NUMBER_OF_PARTS = 5;
export const MIN_TIME_WEIGHTED_NUMBER_OF_PARTS = 2;
export const MAX_TIME_WEIGHTED_NUMBER_OF_PARTS = 30;
